let trackedAbortControllers: Array<AbortController> = [];

/**
 * Create a new AbortController and track it.
 *
 * @returns {AbortController} The newly created AbortController.
 */
export const track = (): AbortController => {
    const abortController = new AbortController();
    trackedAbortControllers.push(abortController);
    return abortController;
};

/**
 * Remove an AbortController from the list of tracked AbortControllers.
 * @param controller The AbortController to remove.
 */
export const untrack = (controller: AbortController): void => {
    trackedAbortControllers = trackedAbortControllers.filter(
        (abortController) => {
            return abortController !== controller;
        },
    );
};

/**
 * Abort all currently tracked AbortControllers.
 *
 * This also clears the list of tracked AbortControllers.
 */
export const abortAll = (): void => {
    const toBeAborted = [...trackedAbortControllers];
    trackedAbortControllers = [];
    toBeAborted.forEach((abortController) => {
        abortController.abort();
    });
};

/**
 * Untrack all tracked AbortControllers.
 *
 * This does not abort any AbortControllers.
 */
export const untrackAll = (): void => {
    trackedAbortControllers = [];
};
